import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: React.ReactNode;
  icon?: JSX.Element;
}

const SecondaryButton = ({ className, children, ...props }: ButtonProps) => {
  return (
    <button
      className={`font-gtAmerica leading-none flex items-center gap-2 px-3 sm:px-8 py-3 sm:py-4 text-[16px] font-medium bg-white rounded-full ${
        className ? className : ""
      }`}
      {...props}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
